import { IInitialisable } from "src/scripts/interfaces/IInitialisable";
import { gtm } from "./gtm";
import { SearchWindowType } from "src/scripts/typings/WindowType";
export class GtmConsentAll implements IInitialisable {
	protected windowHelper = window as SearchWindowType;

	// Tested
	Init(): void {
		this.setGtmDefaultConsent();
		this.loadGtm();
	}

	// Tested
	protected setGtmDefaultConsent(): void {
		const windowScope = this.windowHelper;
		windowScope.gtag = function () {
			windowScope.dataLayer = windowScope?.dataLayer || [];
			windowScope.dataLayer.push(arguments);
		};
	}

	protected loadGtm() {
		gtm();
	}
}
